import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    ReferenceField,
    TextField,
} from 'react-admin';
import EnvironmentTitle from './EnvironmentTitle';

const EnvironmentShow = props => (
    <Show title={<EnvironmentTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <ReferenceField label="Project" source="project_id" reference="projects">
                <TextField source="name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

export default EnvironmentShow;